<ng-container *ngIf="!banMensaje">
    <ng-container *ngIf="informacionPerfil && informacionPerfil.mensajeINTPTO">
        <div class="no-hay-informacion">
            <label>{{ informacionPerfil.mensajeINTPTO }}</label>
        </div>
      </ng-container>
    <div *ngIf="informacionPerfil && !informacionPerfil.mensajeINTPTO">
        <div class="titulo-sub-seccion">
            <p>{{ 'PERFILCREZCAMOS.LBL_OBLIGACIONESVIGENTESCREZCAMOS' | translate}}</p>
        </div>
        <div class="contenedos-obligaciones-vigentes">
            <ng-container *ngIf="obligacionesVigentes && obligacionesVigentes.length > 0">
                <p-table class="tabla-gris" [columns]="columnasObligacionesVigentes" [value]="obligacionesVigentes" [paginator]="true"
                        [rows]="10" [responsive]="true" paginatorPosition="bottom">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                            class="text-center">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr [pSelectableRow]="row">
                            <td class="text-center">{{ row.participacion ? row.participacion : '-'}}</td>
                            <td class="text-center">{{ row.numeroCredito ? row.numeroCredito : '-'}}</td>
                            <td class="text-center">{{ row.diasMora || row.diasMora === 0 ? ( row.diasMora ) : '-'}}</td>
                            <td class="text-center">{{ row.montoDesembolso | formatCurrency }}</td>
                            <td class="text-center">{{ row.cuota | formatCurrency }}</td>
                            <td class="text-center">{{ row.plazo || row.plazo === 0 ? ( row.plazo ) : '-'}}</td>
                            <td class="text-center">{{ ( row.tasaEA && row.tasaEA !== '-' )|| +row.tasaEA === 0 ? ( row.tasaEA | number: '1.2-2') + '%' : '-' }}</td>
                            <td class="text-center">{{ row.frecuenciaPago ? row.frecuenciaPago : '-'}}</td>
                            <td class="text-center width-column">{{ row.fechaDesembolso? (transformDate(row.fechaDesembolso) | date:'yyyy-MM-dd' ) : '-'}}</td>
                            <td class="text-center">{{ row.saldoCapital | formatCurrency }}</td>
                            <td class="text-center">{{ row.pagoTotal | formatCurrency }}</td>
                            <td class="text-center">{{ row.valorMora | formatCurrency }}</td>
                            <td class="text-center width-column">{{ row.altura ? row.altura : '-'}}</td>
                            <td class="text-center">{{ ( row.moraMaxima && row.moraMaxima.toString() !== '-' ) || row.moraMaxima === 0 ? ( row.moraMaxima ) : '-' }}</td>
                            <td class="text-center">{{ ( row.liquidacion && row.liquidacion !== '-' ) || +row.liquidacion === 0 ?(  row.liquidacion  | formatCurrency  ): '-'  }}</td>
                            <td class="text-center">{{ row.ingresos | formatCurrency }}</td>
                            <td class="text-center">{{ row.activos | formatCurrency }}</td>
                            <td class="text-center">{{ row.patrimonio | formatCurrency }}</td>
                            <td class="text-center">{{ row.garantia ? row.garantia : '-' }}</td>
                            <td class="text-center">
                                <div class="btn-group" role="group">
                                    <div class="contador-firmantes">
                                        <i class="fa fa-user-o" aria-hidden="true"></i>
                                        {{ row.firmantes ? row.firmantes.length : 0 }}
                                    </div>
                                    <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                                            title="{{'BTN_VISUALIZAR' | translate}}" pButton (click)="visualizarFirmantes(row)">
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td class="text-center" [attr.colspan]="columns.length">
                            {{ 'MSG_NOHAYREGISTROS' | translate}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </ng-container>
            <ng-container *ngIf="obligacionesVigentes && obligacionesVigentes.length === 0">
                <div class="no-hay-informacion">
                <label>{{'PERFILCREZCAMOS.LBL_NOHAYINFORMACIONPARAMOSTRAR' | translate}}</label>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
<div class="no-hay-informacion" *ngIf="banMensaje">
    <label>{{'PERFILCREZCAMOS.LBL_NOHAYINFORMACIONPARAMOSTRAR' | translate}}</label>
</div>
